export default __webpack_public_path__ + "locales/pt/FilesSettings.json?hash=cfcb1790a19dfdc69d1b4cec5ec8b4ee";